import React from 'react'
import PropType from 'prop-types'
import Button from '../Button'
import Icon from '../../Icon'
import styles from './SaveButtonStyles'

function SaveButton({
  handleClick, className, showIcon, label,
}) {
  const classes = styles()
  return (
    <Button
      variant="outlined"
      className={`${classes.button} ${className}`}
      onClick={handleClick()}
    >
      {showIcon && <div><Icon color="##fff" iconName="Save" /></div>}
      <span style={{ marginLeft: '5px', paddingBottom: '3px' }}>{label}</span>
    </Button>
  )
}

SaveButton.defaultProps = {
  className: '',
  handleClick: () => null,
  label: 'Speichern',
  showIcon: false,
}

SaveButton.propTypes = {
  className: PropType.string,
  handleClick: PropType.func,
  label: PropType.string,
  showIcon: PropType.bool,
}

export default SaveButton
